import {CATEGORY_ALL, DISCOVER_TAB} from '../page/discover/discoverConstants';
import {SELLER_TAB} from '../page/seller/sellerConstants';

import {seoURIComponent} from './text';

export function webappURL(hostname) {

    let uri;
    switch (hostname) {
        case 'localhost':
            uri = 'http://localhost:3000';
            break;
        case 'staging.fruitsfamily.com':
            uri = 'https://staging.fruitsfamily.com';
            break;
        case 'production.fruitsfamily.com':
        case 'fruitsfamily.com':
        case 'www.fruitsfamily.com':
            uri = 'https://fruitsfamily.com';
            break;
        default:
            uri = 'https://fruitsfamily.com';
            break;
    }
    return uri;
}

export function brandUrl(brandName, category = CATEGORY_ALL) {
    return [
        '/brand',
        encodeURIComponent(brandName),
        category === CATEGORY_ALL ?
            null :
            encodeURIComponent(category.name)
    ].filter(component => component).join('/');
}

export function collectionUrl(collection) {
    const collectionId = parseInt(collection.id, 10);

    return [
        '/collection',
        encodeURIComponent(collectionId.toString(36)),
        seoURIComponent(collection.title)
    ].filter(component => component).join('/');
}

export function discoverUrl(discoverTab = DISCOVER_TAB.PRODUCT, category = CATEGORY_ALL) {
    return [
        '/discover',
        discoverTab === DISCOVER_TAB.PRODUCT && category === CATEGORY_ALL ?
            null :
            seoURIComponent(discoverTab.description),
        discoverTab === DISCOVER_TAB.SHOP || category === CATEGORY_ALL ?
            null :
            encodeURIComponent(category.name)
    ].filter(component => component).join('/');
}

export function downloadUrl() {
    return '/download';
}

export const sellUrl = () => '/sell';
export const feesUrl = () => '/sell/fees';

export function homeUrl() {
    return '/';
}

export function productUrl(product) {
    const productId = parseInt(product.id, 10);

    if (productId === -1) {
        return '';
    }
    return `/product/${encodeURIComponent(productId.toString(36))}/${seoURIComponent(product.title)}`;
}

export function sellerUrl(seller, sellerTab = SELLER_TAB.SHOP) {
    const sellerId = parseInt(seller.id, 10);
    const userName = seller.user !== undefined ? seller.user.username : seller.username

    return [
        '/seller',
        encodeURIComponent(sellerId.toString(36)),
        seoURIComponent(userName),
        sellerTab === SELLER_TAB.SHOP ?
            null :
            seoURIComponent(sellerTab.description)
    ].filter(component => component).join('/');
}

export function searchUrl(keyword, category = CATEGORY_ALL) {
    return [
        '/search',
        encodeURIComponent(keyword),
        category === CATEGORY_ALL ?
            null :
            encodeURIComponent(category.name)
    ].filter(component => component).join('/');
}

export function searchUrlWithHostname(hostname, keyword, category = CATEGORY_ALL) {
    const baseUrl = webappURL(hostname);
    const path = searchUrl(keyword, category);
    return `${baseUrl}${path}`;
}

export function signUpUrl() {
    return '/signUp';
}

export function signUpSns(snsType, snsToken) {
    return '/signUpSns?snsType=' + snsType + '&token=' + snsToken;
}

export function loginUrl() {
    return '/login';
}

export function myPageUrl(sellerTab = SELLER_TAB.SHOP) {
    return  [
        '/my',
        sellerTab === SELLER_TAB.SHOP ?
            null :
            seoURIComponent(sellerTab.description)
    ].filter(component => component).join('/');
}

export function uploadUrl() {
    return '/upload';
}

export function checkoutUrl(product) {
    const productId = parseInt(product.id, 10);

    return `/checkout/${encodeURIComponent(productId.toString(36))}`;
}

export function friendInviteUrl(code) {
    return `/event/join/${code}`;
}

export function sellerCollectionUrl(sellerCollection) {
    if (!sellerCollection) {
        return '/vintage-shops';
    }

    const sellerCollectionId = parseInt(sellerCollection.id, 10);
    const base = `/vintage-shops/${encodeURIComponent(sellerCollectionId.toString(36))}`;

    //일부 오류가 발생할수 있기에 안전하게 처리
    if (!sellerCollection.title) {
        return base;
    }

    return `${base}/${seoURIComponent(sellerCollection.title)}`;
}

export function collectionsUrl() {
    return '/collections';
}

export function brandRankingUrl() {
    return '/brand-ranking';
}

export function brandRadarUrl(brandName) {
    if (!brandName) return '/brand-radar';
    return `/brand-radar/${encodeURIComponent(brandName)}`;
}

export function searchUrlByGender(gender, subcategoryId) {
    const params = new URLSearchParams({ gender, subcategoryIds: subcategoryId, sort: 'POPULAR' });
    return `/search?${params}`;
}

export function searchUrlByCategoryName(categoryName, subcategoryId) {
    const params = new URLSearchParams({ categoryName, subcategoryIds: subcategoryId, sort: 'POPULAR' });
    return `/search?${params}`;
}

/**
 * hostname에 따라 광고 ID를 리턴
 * @param {string} hostname — window.location.hostname 등
 * @returns {string} 광고 ID
 */
export function getRectangleAdId(hostname) {
    let adId;
    switch (hostname) {
        case 'localhost':
        case 'staging.fruitsfamily.com':
            adId = 'DAN-I11q2QnSbpbj9mCl';
            break;
        case 'production.fruitsfamily.com':
        case 'fruitsfamily.com':
        case 'www.fruitsfamily.com':
            adId = 'DAN-XewKfcVQoiUq3lEH';
            break;
        default:
            adId = 'DAN-I11q2QnSbpbj9mCl';
            break;
    }
    return adId;
}

/**
 * 상품 상세 - hostname에 따라 광고 ID를 리턴
 * @param {string} hostname — window.location.hostname 등
 * @returns {string} 광고 ID
 */
export function getProductDetailAdId(hostname) {
    let adId;
    switch (hostname) {
        case 'localhost':
        case 'staging.fruitsfamily.com':
            adId = 'DAN-2qTdg5DfJwLahBUJ';
            break;
        case 'production.fruitsfamily.com':
        case 'fruitsfamily.com':
        case 'www.fruitsfamily.com':
            adId = 'DAN-2RqZpr9hQN8pyAVT';
            break;
        default:
            adId = 'DAN-2qTdg5DfJwLahBUJ';
            break;
    }
    return adId;
}
